import React, { Component, PureComponent } from "react";
import { connect } from "react-redux";
class Play extends PureComponent {
  componentDidUpdate(data) {
    myVideo.playbackRate = this.props.videoSpeed;
    if (data.videoSrc != this.props.videoSrc) {
      // 自定义video
      myVideo.src=this.props.videoSrc;
      myVideo.loop=this.props.videoData.nextPath=="loop";
      myVideo.toPlayFn();
    }
  }
  render() {
    const { state, props } = this;
    return (
      <div>
        {/* <video
          id="myVideo"
          playsinline="true"
          webkit-playsinline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-video-orientation="portrait"
          className="full_video"
          loop={props.videoData.nextPath == "loop"}
          src={props.videoSrc}
        ></video> */}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Play);
